import styled from "styled-components";


export const Wrapper = styled.div`
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media only screen and (width: 1920px) and (height: 1081px) {
    margin-left:200px ;
    margin-right:200px ;
  }
    margin-left:30px;
    margin-top: 30px;


`

export const FormWrapper = styled.div`
    margin-top: 49px;
    padding-right:70px;
    @media only screen and (min-width: 1920px) and (min-height: 1081px) {
    width: 100%;
    margin-left: 100px;
  }
`
export const FormHeader = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`
export const Title = styled.div`
width: 100%;
font-style: normal;
font-weight: var(--general-header-font-weight);
font-size: var(--general-header-font-size);
line-height: 24px;
color: var(--font-color-blue002e5c);
text-align: center;
margin-bottom: 15px;
`
export const Description = styled.div`
width: 454px;
height: 27px;
text-align: center;
color: var(--font-color-blue002e5c);
`
export const Label = styled.label`
font-weight: var(--general-small-label-font-weight);
font-size: var(--general-small-label-font-size);
line-height: 18px;
color: var(--font-color-blue002e5c);
padding-left: 20px;

`
export const LabelCheckBox = styled.label`
font-style: normal;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 19px;
color: var(--font-color-slate404253);
`
